module.exports = __webpack_public_path__ + "img/RESERVATION_GRILLE_POINTAGE_DISABLED.8184ce98.svg";